package br.com.texeratx.boardgametimeapp.ui.screens.clan

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings
import br.com.texeratx.boardgametimeapp.core.image.LocalImagePreview
import br.com.texeratx.boardgametimeapp.ui.components.PlayerAvatar
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppLoadingOverlay
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppScreenScaffold
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppTopBarColors

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ClanUI(
    state: ClanUiState,
    onBack: () -> Unit,
    onRetry: () -> Unit,
    onEdit: () -> Unit,
    onCancel: () -> Unit,
    onNameChange: (String) -> Unit,
    onRequireApprovalChange: (Boolean) -> Unit,
    onPickImage: () -> Unit,
    onClearImage: () -> Unit,
    onSave: () -> Unit,
    onOpenMembers: () -> Unit,
    onLeave: () -> Unit,
) {
    val S = LocalStrings.current
    AppScreenScaffold(
        topBar = {
            TopAppBar(
                title = { Text(S.clanTitle, fontWeight = FontWeight.Bold) },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(Icons.Default.ArrowBack, contentDescription = S.back)
                    }
                },
                colors = AppTopBarColors(),
            )
        }
    ) { padding ->
        Box(
            modifier = Modifier
                .padding(padding)
                .fillMaxSize()
        ) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(rememberScrollState())
                    .padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                state.error?.let { msg ->
                    Card(shape = RoundedCornerShape(16.dp)) {
                        Column(Modifier.padding(12.dp)) {
                            Text(S.errorTitle, fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error)
                            Spacer(Modifier.height(4.dp))
                            Text(msg)
                            Spacer(Modifier.height(10.dp))
                            OutlinedButton(onClick = onRetry, modifier = Modifier.fillMaxWidth()) {
                                Text(S.retry)
                            }
                        }
                    }
                }

                Card(shape = RoundedCornerShape(16.dp), modifier = Modifier.fillMaxWidth()) {
                    Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
                        PlayerAvatar(
                            imageUrl = state.clan?.imageUrl,
                            contentDescription = state.clan?.name,
                            size = 90.dp
                        )

                        Text(
                            text = state.clan?.name ?: S.loading,
                            style = MaterialTheme.typography.titleLarge,
                            fontWeight = FontWeight.Bold
                        )

                        if (!state.isEditing) {
                            InfoRow(label = S.labelClanName, value = state.clan?.name ?: "-")
                            InfoRow(
                                label = "Aprovação manual",
                                value = if (state.clan?.requireApproval == true) "Sim" else "Não"
                            )

                            Spacer(Modifier.height(6.dp))

                            if (state.isAdmin) {
                                Button(
                                    onClick = onEdit,
                                    enabled = state.clan != null && !state.isLoading && !state.isSaving,
                                    modifier = Modifier.fillMaxWidth()
                                ) { Text(S.edit) }
                            }
                        } else {
                            OutlinedTextField(
                                value = state.nameInput,
                                onValueChange = onNameChange,
                                label = { Text(S.labelClanName) },
                                singleLine = true,
                                modifier = Modifier.fillMaxWidth()
                            )

                            if (state.isOwner) {
                                Row(
                                    modifier = Modifier.fillMaxWidth(),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Text(
                                        text = "Exigir aprovação do admin",
                                        modifier = Modifier.weight(1f)
                                    )
                                    Switch(
                                        checked = state.requireApprovalInput,
                                        onCheckedChange = onRequireApprovalChange
                                    )
                                }
                            }

                            Text(
                                text = S.sectionPhotoAvatar,
                                style = MaterialTheme.typography.titleMedium,
                                fontWeight = FontWeight.Bold
                            )

                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.spacedBy(8.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                OutlinedButton(
                                    onClick = onPickImage,
                                    enabled = !state.isSaving && !state.isUploadingImage
                                ) { Text(S.selectImage) }

                                OutlinedButton(
                                    onClick = onClearImage,
                                    enabled = state.selectedImageName != null && !state.isSaving && !state.isUploadingImage
                                ) { Text(S.remove) }

                                if (state.isUploadingImage) {
                                    CircularProgressIndicator(
                                        modifier = Modifier.size(22.dp),
                                        strokeWidth = 2.dp
                                    )
                                }
                            }

                            if (state.localImageBytes != null) {
                                LocalImagePreview(
                                    bytes = state.localImageBytes,
                                    contentDescription = S.previewAvatar,
                                    modifier = Modifier
                                        .width(160.dp)
                                        .height(160.dp)
                                        .clip(CircleShape)
                                )
                            } else {
                                PlayerAvatar(
                                    imageUrl = state.clan?.imageUrl,
                                    contentDescription = state.clan?.name,
                                    size = 90.dp
                                )
                            }

                            Row(Modifier.fillMaxWidth()) {
                                OutlinedButton(
                                    onClick = onCancel,
                                    enabled = !state.isSaving && !state.isUploadingImage,
                                    modifier = Modifier.weight(1f)
                                ) { Text(S.cancel) }

                                Spacer(Modifier.width(12.dp))

                                Button(
                                    onClick = onSave,
                                    enabled = !state.isSaving && !state.isUploadingImage,
                                    modifier = Modifier.weight(1f)
                                ) { Text(if (state.isSaving) S.saving else S.save) }
                            }
                        }
                    }
                }

                if (state.isAdmin) {
                    Button(
                        onClick = onOpenMembers,
                        modifier = Modifier.fillMaxWidth()
                    ) { Text("Gerenciar membros e convites") }
                }

                if (!state.isOwner) {
                    OutlinedButton(
                        onClick = onLeave,
                        enabled = !state.isLeaving,
                        modifier = Modifier.fillMaxWidth()
                    ) { Text(if (state.isLeaving) "Saindo..." else "Sair do clã") }
                }
            }

            AppLoadingOverlay(isVisible = state.isLoading)
        }
    }
}

@Composable
private fun InfoRow(label: String, value: String) {
    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
        Text(label, color = MaterialTheme.colorScheme.onSurfaceVariant, style = MaterialTheme.typography.bodySmall)
        Text(value, fontWeight = FontWeight.SemiBold)
    }
}
